import { useQuery } from '@tanstack/react-query';
import { getClinicProductSuggestions } from '../requests';
import { ClinicProduct } from '../types';

export interface UseClinicProductSuggestionsReturn {
  clinicProductSuggestions: ClinicProduct[];
  isLoading: boolean;
  clearResponse: () => void;
  isFetched: boolean;
}

const useClinicProductSuggestions = (masterMedicineId?: string): UseClinicProductSuggestionsReturn => {
  const { data, isLoading, remove, isFetched } = useQuery({
    queryFn: () => (masterMedicineId ? getClinicProductSuggestions(masterMedicineId) : null),
    queryKey: ['clinic-product-suggestions', masterMedicineId],
    enabled: Boolean(masterMedicineId)
  });

  const clinicProductSuggestions = data?.data.data || [];

  return {
    clinicProductSuggestions,
    isLoading,
    clearResponse: remove,
    isFetched
  };
};

export default useClinicProductSuggestions;
